import React from "react";
import ServiceSectionComponent from "./ServiceSectionComponent";

const ServiceSection = ({isHide}) => {
  return (
    <>
      <ServiceSectionComponent isHide={isHide} />
      {/* <Hidden mdDown>
        <PartnerSection />
      </Hidden>
      <Hidden mdUp>
        <MobilePartnerSection />
      </Hidden> */}
    </>
  );
};

export default ServiceSection;
